export const Reproved = ({ size = 11 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 11 11"
  >
    <path
      stroke="#E00030"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m6.85 4.15-2.7 2.7m0-2.7 2.7 2.7M10 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0"
    />
  </svg>
);
